var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notify alert alert-dismissible",class:{
        'alert-success': _vm.message.type === 'success',
        'alert-danger': _vm.message.type === 'danger',
        'alert-warning': _vm.message.type === 'warning',
        'alert-warning': _vm.message.type === 'loading'
    }},[(_vm.message.close)?_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"alert"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e(),_vm._v(" "+_vm._s(_vm.message.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }